import * as Api from "utils/api/api";
import {handleError} from "utils/errorHandle.function";
import {
    EVENT_TYPES,
    DAYS_OF_THE_WEEK,
    DAYS_OF_THE_WEEK_NUMBER,
    USER_TYPE,
    SETTINGS_AVAILABLE_HOURS
} from "types/settings";


export async function getNotifications() {
    try {
        const response = await Api.getEmailSettings();

        const initializer = {
            overdueRemainder: undefined,
            dateTime: {
                [USER_TYPE.APPROVER]: mapDays(),
                [USER_TYPE.ADMIN]: mapDays(),
            },
        };

        const value = response.digestMail ? response.digestMail.reduce((acc, email) => {
                switch (email.digestMailType) {
                    case EVENT_TYPES.EMAIL_ENABLED:
                        acc.overdueRemainder = email.mailEnabled;
                        break;
                    case EVENT_TYPES.EMAIL_EVENTS:
                        acc.dateTime[USER_TYPE.APPROVER] = mapDays(email.events);
                        break;
                    case EVENT_TYPES.ADMIN_EMAIL_EVENTS:
                        acc.dateTime[USER_TYPE.ADMIN] = mapDays(email.events);
                        break;
                }
                return acc;
            }, initializer)
            : initializer;

        return {
            newTaskForApprover: response.eventMail?.includes(EVENT_TYPES.NEW_APPROVAL_TASK) || false,
            appointedAsSubstitute: response.eventMail?.includes(EVENT_TYPES.APPOINTED_SUBSTITUTE) || false,
            taskBlocked: response.eventMail?.includes(EVENT_TYPES.TASK_BLOCKED) || false,
            documentBlocked: response.eventMail?.includes(EVENT_TYPES.DOCUMENT_BLOCKED) || false,
            ...value,
            isUserAdmin: response.userAdmin,
            isUserApprover: response.userApprover
        };
    } catch (error) {
        handleError(error);
    }
}

function mapDays(events = []) {
    const resultDays = DAYS_OF_THE_WEEK.reduce((acc, day) => {
        acc[day] = events.some(event => event.dayOfWeek === DAYS_OF_THE_WEEK_NUMBER[day]);
        return acc;
    }, {});
    const resultHours = SETTINGS_AVAILABLE_HOURS.reduce((acc, hour) => {
        acc[hour] = events.some(event => event.hourOfDay === hour);
        return acc;
    }, {});

    const result = {
        days: resultDays,
        hours: resultHours,
    }

    return result;
}